export default "__VITE_ASSET__8PUnb_pk__"